<template>
  <div
    @mouseleave="hideHeader"
    @mouseenter="showHeader"
    :active="active"
    @click="goToPage()"
    :position="position"
  >
    <span class="text recent-item truncate-text" :class="{ active: active }">{{
      letter
    }}</span>
    <!-- <div
      id="close"
      @click="removeRecentPage"
      class="otz-icon remove remove-user-tsiyun no-bg"
    >
      F
    </div> -->

    <!-- <div>
      <BaseIcon
        @click="importantRecent"
        id="icon"
        class="icon"
        width="13"
        height="15"
        :nameIcon="sticky == 1 ? 'pinter-active' : 'pinter-gray'"
        pathIcon="icons"
      />
    </div> -->
  </div>
</template>

<script>
import Icons from "@/components/Icons/Icons.vue";

export default {
  components: { Icons },
  data() {
    return {
      headerTimer: null,
    };
  },
  props: ["name", "letter", "active", "tabId", "position", "sticky"],
  computed: {
    title() {
      return this.letter;
    },
  },
  methods: {
    async goToPage() {
      this.$store.state.tabsManager.userClick = true;
      this.hideHeader();
      this.$emit("click", this.id);
    },
    importantRecent() {
      const pos = this.position;
      const modifiedPage = { position: pos, sticky: this.sticky };
      this.$store.dispatch(`tabs/${this.tabId}/updateRecentPage`, modifiedPage);
    },
    removeRecentPage() {
      this.$store.dispatch(`tabs/${this.tabId}/delRecentPage`, this.position);
    },
    showHeader() {
      if (this.position == 0) return;
      this.$emit("mouseenter", {
        pageId: this.name,
        top: this.$el.getBoundingClientRect().top,
        left: this.$el.getBoundingClientRect().left,
        pos: this.position,
      });
    },
    hideHeader() {
      this.$emit("mouseleave");
    },
  },
  destroyed() {
    if (this.headerTimer) clearTimeout(this.headerTimer);
  },
};
</script>

<style lang="scss" scoped>
.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.recent-item {
  display: flex;
  height: 22px;
  padding: 5px !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: 1px solid;
  border-color: var(--custom-color1);
  background: #fff;
  cursor: pointer;
  margin-right: 3px;
  margin-bottom: 3px;
  &:hover {
    background-color: #e5e5e5;
  }
  &.active {
    background-color: var(--custom-color1);
    color: white;
  }
}
.item {
  text-align: right;
}
.empty-page {
  color: lightgrey;
  cursor: pointer;
}
#icon {
  position: absolute;
  top: 28%;
  left: 10px;
}
#close {
  position: absolute;
  left: 19px;
}
</style>
